import { CopyButton } from "../ui/CopyButton";
import { useDarkMode } from "../../hooks/useDarkMode";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import vscDarkPlus from "react-syntax-highlighter/dist/esm/styles/prism/vsc-dark-plus";
import vs from "react-syntax-highlighter/dist/esm/styles/prism/vs";

interface ArticleCodeBlockProps {
  code: string;
  language: string;
}

export function ArticleCodeBlock({ code, language }: ArticleCodeBlockProps) {
  const { isDark } = useDarkMode();

  return (
    <div className="not-prose relative my-6 rounded-lg border border-gray-200 dark:border-zinc-700 bg-gray-50 dark:bg-zinc-800 overflow-hidden [&_pre]:bg-transparent! [&_code]:bg-transparent!">
      <div className="absolute top-2 right-2 z-10">
        <CopyButton text={code} ariaLabel="Copy code" />
      </div>
      <SyntaxHighlighter
        language={language}
        style={isDark ? vscDarkPlus : vs}
        customStyle={{
          margin: 0,
          padding: "0.75rem",
          paddingRight: "3rem",
        }}
        codeTagProps={{
          style: {
            fontSize: "0.875rem",
            fontFamily:
              "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
          },
        }}
      >
        {code}
      </SyntaxHighlighter>
    </div>
  );
}
